function getStatusText(status) {
  return Number(status) === 1 ? '启用' : '禁用';
}

module.exports = (s) => {
  return [
    {
      name: 'ID',
      value: 'id',
      width: 90,
    },
    {
      name: 'Client ID',
      value: 'client_id',
      width: 180,
    },
    {
      name: '客户端名称',
      value: 'name',
      width: 180,
    },
    {
      name: '描述',
      value: 'description',
      props: {
        'min-width': 180,
      },
      format: row => row.description || '-',
    },
    {
      name: '授权范围',
      value: 'scopes',
      props: {
        'min-width': 220,
      },
      format: row => s.formatScopeText(row.scopes),
    },
    {
      name: '状态',
      value: 'status',
      width: 90,
      format: (row) => {
        const h = s.$createElement;
        return h('el-tag', {
          props: {
            size: 'mini',
            type: Number(row.status) === 1 ? 'success' : 'info',
          },
        }, getStatusText(row.status));
      },
    },
    {
      name: '创建时间',
      value: 'created_at',
      width: 170,
      format: row => row.created_at || '-',
    },
    {
      name: '操作',
      value: 'operation',
      width: 240,
      fixed: 'right',
      format: (row) => {
        const h = s.$createElement;
        const buttons = [
          h('el-button', {
            props: {
              size: 'mini',
              type: 'primary',
              plain: true,
            },
            on: {
              click: () => s.edit(row),
            },
          }, '编辑'),
        ];

        if (Number(row.status) === 0) {
          buttons.push(h('el-button', {
            props: {
              size: 'mini',
              type: 'primary',
              plain: true,
            },
            on: {
              click: () => s.enable(row),
            },
          }, '启用'));
        } else {
          buttons.push(h('el-button', {
            props: {
              size: 'mini',
              plain: true,
            },
            on: {
              click: () => s.disable(row),
            },
          }, '禁用'));
        }

        buttons.push(
          h('el-button', {
            props: {
              size: 'mini',
              type: 'danger',
              plain: true,
            },
            on: {
              click: () => s.delete(row),
            },
          }, '删除')
        );

        return h('div', null, buttons);
      },
    },
  ];
};
